/**
 * TeamSystem Impact - Report API Client
 * API calls for report assessment data (KPI values, etc.)
 */

import { apiClient } from '../../../api/client';
import type { KpiValuesResponse } from '@teamsystem-impact/shared';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

const BASE_PATH = '/data-capture/report';

export const reportApi = {
  /**
   * GET /campaigns/:id/kpis?codes=...
   * Restituisce i valori correnti dei KPI richiesti per la campagna.
   */
  getKpis: async (campaignId: string, codes: string[]): Promise<KpiValuesResponse> => {
    if (codes.length === 0) return { kpis: [] };
    const params = new URLSearchParams();
    params.append('codes', codes.join(','));
    const response = await apiClient.get<ApiResponse<KpiValuesResponse>>(
      `${BASE_PATH}/campaigns/${campaignId}/kpis?${params.toString()}`
    );
    if (!response.data.success) {
      throw new Error(response.data.error || 'Errore caricamento KPI');
    }
    return response.data.data!;
  },
};
